import React from 'react';
import { Outlet } from 'react-router-dom';
import SideBar from '../components/Sidebar';
import { useSidebar } from '../contexts/Sidebarcontext';

const AdminLayout = () => {
  const { isOpen, close } = useSidebar();

  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden ">
      <div className="flex flex-1 ">
        {/* Sidebar renders desktop rail + mobile drawer */}
        <SideBar isOpen={isOpen} onClose={close} />
        <main className="flex-1 w-full">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
